import { render, staticRenderFns } from "./CommonMenuItemAside.vue?vue&type=template&id=43c9158a"
import script from "./CommonMenuItemAside.vue?vue&type=script&lang=js"
export * from "./CommonMenuItemAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports